// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import Loading from "components/lib/loading";
import CenterContainer from "components/lib/center-container";
import Axios from 'axios'
import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
import Datepicker from 'vuejs-datepicker'
import titleMixin from './mixins/titleMixin'
import 'vue2-timepicker/dist/VueTimepicker.css'

Vue.mixin(titleMixin)
Vue.config.productionTip = false;

Vue.component("vue-datepicker", Datepicker);
Vue.component("vue-timepicker", VueTimepicker);
Vue.component("loading", Loading);
Vue.component("center-container", CenterContainer);
Vue.prototype.$http = Axios;

//https://forum.vuejs.org/t/how-to-format-date-for-display/3586/5
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY hh:mm')
  }
});
Vue.filter('formatDateDay', function (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY')
  }
});
Vue.filter('hour', function (value) {
  if (value) {
    value = (Math.round(value * 4) / 4).toFixed(2);
    var formatter = new Intl.NumberFormat('de-DE', {
      // These options are needed to round to whole numbers if that's what you want.
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formatter.format(value);
  } else {
    return "0,00";
  }
});
Vue.filter('momentHour', function (value) {
  if (value) {
    return moment(value).format('HH:mm');
  } else {
    return "0:00";
  }
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});

console.log(process.env.VUE_APP_API_PATH);
